import { useEffect } from "react";

const ADS_ID = "AW-18493522406";
// Conversione Google Ads "Contatto" (parte dopo "AW-18493522406/")
const CONTATTO = "nagrCPbNtZAdEOaDs_JE";
export const ETICHETTE_CONVERSIONE = {
  click_chiama: CONTATTO,
  click_whatsapp: CONTATTO,
  richiesta_inviata: CONTATTO,
};

export const traccia = (evento, dati = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: evento, ...dati });
  const label = ETICHETTE_CONVERSIONE[evento];
  if (label && typeof window.gtag === "function") {
    window.gtag("event", "conversion", { send_to: `${ADS_ID}/${label}`, value: 1.0, currency: "EUR" });
  }
};

export const useTracciamentoContatti = (numeroWhatsApp) => {
  useEffect(() => {
    const onClick = (e) => {
      if (window.location.pathname.startsWith("/gestione")) return;
      const a = e.target.closest?.("a[href]");
      if (!a) return;
      const href = a.getAttribute("href");
      const posizione = a.dataset.testid || "";
      if (href.startsWith("tel:")) traccia("click_chiama", { posizione });
      else if (href.includes(`wa.me/${numeroWhatsApp}`)) traccia("click_whatsapp", { posizione });
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, [numeroWhatsApp]);
};
